import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full sm:w-6/12 text-center mx-auto justify-center p-2" }
const _hoisted_2 = { class: "text-center my-2 text-gray-700" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "w-9/12 m-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mx-auto" }, "マイページに戻る", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_ContinuouslyExchangeCards = _resolveComponent("ContinuouslyExchangeCards")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseCard, { class: "p-2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.exchangeConfigTitle), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.exchangeConfigSubTitle), 1)
        ]),
        (_ctx.defeatPageConfig?.defeat_image_path)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.defeatPageConfig.defeat_image_path,
              class: "w-9/12 m-auto my-3"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, { to: _ctx.mypageLinkTo }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BaseButton, {
                class: "w-full",
                buttonClass: "main"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }),
    _createVNode(_component_ContinuouslyExchangeCards, { class: "mt-2" })
  ]))
}